import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
// components
import LoadingScreen from '../components/minimal/loading-screen';
//
import Login from '../pages/auth/LoginPage';
import { useAuthContext } from '../context-state/AuthContext';
// Inactivity logout
import { useInactivityLogout } from '../hooks/useInactivityLogout';
import InactivityWarningDialog from '../components/InactivityWarningDialog';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {

  const { isAuthenticated, isInitialized, setChosenAccount, account } = useAuthContext();

  const { pathname } = useLocation();
  const { subId } = useParams();

  const [requestedLocation, setRequestedLocation] = useState(null);

  // Initialize inactivity logout
  const { showWarning, resetTimer } = useInactivityLogout();

  useEffect(() => {
    // here we unset the chosen account if the user is not in a sub account route.
    if (account && !subId) {
      setChosenAccount(null);
    }
  }, [account?._id, subId]);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return (
    <>
      {children}

      {/* Inactivity warning dialog */}
      <InactivityWarningDialog
        open={showWarning}
        onStayLoggedIn={resetTimer}
      />
    </>
  );
}
